import {ButtonStyle, useTranslation, MyIntegration, SUCCESS_REPONSE_CODE, UNPROCESSABLE_ENTITY_RESPONSE_CODE, handleOtherResponseCode, toastr, CustomToastrAction} from '@/imports-files/pages/clients/activities/my-integrations';

export function createIntegrationData(index, client_integration_id, integration_id, slug, name, description, user_enabled, is_linkable, logo, accessible, connected, redirect_url)
{
  return { index, client_integration_id, integration_id, slug, name, description, user_enabled, is_linkable, logo, accessible, connected, redirect_url};
} 

export function getIntegrationsStatus(row, t){
  if (row.is_linkable){
    return row.connected ? t('button:disconnect') : t('button:connect');
  }
}

export function getButtonClass(row){
  if (row.is_linkable){
    return row.connected ? ButtonStyle.secondarybtnborder : ButtonStyle.secondarybtn;
  }
}


export async function connectDisconnectIntegration(event, router, row, setApiError)
{
  const params = {integrate_level: 'user'}
  if(row.connected)
  {  
    const result              =   await new MyIntegration().disconnectIntegration(params, row.slug);
    const status_code         =   result.status || result.response.status;
    const customToastrAction  =   new CustomToastrAction(); 

    setApiError(result.request);

    switch (status_code)
    {
      case SUCCESS_REPONSE_CODE:
        let response = result.data;
        if (response.success) {
          row.connected = false
        }
        break;
      case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
        let error = result.response.data.error;
        if (error) {
          customToastrAction.setNormalToastr(result.response.data.error, 'warning');
        }
        break;
      default:
        handleOtherResponseCode(status_code, router)
    }
    return row;
  }else{
    row.redirect_url.length > 0 ? router.push(row.redirect_url) : console.log("Integration is not done yet.")
    return null;
  }
}

export async function getMyIntegrationData( router, setApiError)
{
  var body                        =  {};
  if(router.query.step) body.step =  router.query.step
  const integration_data          =  await new MyIntegration().getIntegrationsData(body);
  setApiError(integration_data.request);
  const my_integrations           =  integration_data?.data?.my_integrations;
  let data                        =  null;
  

  if(integration_data.status == undefined || integration_data.status != 200)
  {
    const error = new Error('An error occurred while fetching the data.')
    error.status = integration_data.response.status
    throw error
  }
  else
  {
    data =  {
              props: {
                        my_integrations,
                        integration_data
                      }
            }
    return data
  }
}